import ModuleContentList from './ModuleContentList';

export default ModuleContentList;
